<template>
  <div class="p-4">
    <div class="card">
      <div class="card-header">
        <h4 class="mb-0">Lookup values</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-10 col-md-10 col-12">
            <div class="row">
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    class="form-control"
                    type="number"
                    step="any"
                    id="brokerage"
                    autocomplete="off_brokerage"
                    placeholder=" "
                    v-model="brokerage"
                  />
                  <label class="floatingLabel" for="brokerage">Brokerage</label>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    autocomplete="off_brokerageVSADefault"
                    id="brokerageVSADefault"
                    placeholder=" "
                    v-model="brokerageVSADefault"
                  />
                  <label class="floatingLabel" for="brokerageVSADefault"
                    >Brokerage VSA Default</label
                  >
                </div>
              </div>

              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    autocomplete="off_GAPInsurance"
                    id="GAPInsurance"
                    placeholder=" "
                    v-model="GAPInsurance"
                  />
                  <label class="floatingLabel" for="email">GAP Insurance</label>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="GAPInsuranceVSA"
                    placeholder=" "
                    autocomplete="off_GAPInsuranceVSA"
                    v-model="GAPInsuranceVSA"
                  />
                  <label class="floatingLabel" for="GAPInsuranceVSA"
                    >GAP Insurance VSA</label
                  >
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="GST"
                    placeholder=" "
                    autocomplete="off_GST"
                    v-model="GST"
                  />
                  <label class="floatingLabel" for="GST">GST</label>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="GSTLimit"
                    placeholder=" "
                    autocomplete="off_GSTLimit"
                    v-model="GSTLimit"
                  />
                  <label class="floatingLabel" for="GSTLimit">GSTLimit</label>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="GSTMaxOnAssets"
                    placeholder=" "
                    autocomplete="off_GSTMaxOnAssets"
                    v-model="GSTMaxOnAssets"
                  />
                  <label class="floatingLabel" for="GSTMaxOnAssets"
                    >GST Max On Assets</label
                  >
                </div>
              </div>

              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="leaseAdminFee"
                    placeholder=" "
                    autocomplete="off_leaseAdminFee"
                    v-model="leaseAdminFee"
                  />
                  <label class="floatingLabel" for="leaseAdminFee"
                    >Lease admin fee</label
                  >
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="leaseAdminFeeVSA"
                    placeholder=" "
                    autocomplete="off_leaseAdminFeeVSA"
                    v-model="leaseAdminFeeVSA"
                  />
                  <label class="floatingLabel" for="leaseAdminFeeVSA"
                    >Lease admin fee VSA</label
                  >
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="mcLeaseFee"
                    placeholder=" "
                    autocomplete="off_mcLeaseFee"
                    v-model="mcLeaseFee"
                  />
                  <label class="floatingLabel" for="mcLeaseFee"
                    >McLease fee</label
                  >
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="PPSRFee"
                    placeholder=" "
                    autocomplete="off_PPSRFee"
                    v-model="PPSRFee"
                  />
                  <label class="floatingLabel" for="PPSRFee">PPSR fee</label>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="medicare"
                    placeholder=" "
                    autocomplete="off_medicare"
                    v-model="medicare"
                  />
                  <label class="floatingLabel" for="medicare">Medicare</label>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="registration"
                    placeholder=" "
                    autocomplete="off_registration"
                    v-model="registration"
                  />
                  <label class="floatingLabel" for="registration"
                    >Registration</label
                  >
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="tyreReplaceFreq"
                    placeholder=" "
                    autocomplete="off_tyreReplaceFreqn"
                    v-model="tyreReplaceFreq"
                  />
                  <label class="floatingLabel" for="tyreReplaceFreq"
                    >Tyre replace freq.</label
                  >
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="tyreWheelInsurance"
                    placeholder=" "
                    autocomplete="off_tyreWheelInsurance"
                    v-model="tyreWheelInsurance"
                  />
                  <label class="floatingLabel" for="tyreWheelInsurance"
                    >Tyre wheel insurance</label
                  >
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="FBTRate"
                    placeholder=" "
                    autocomplete="off_FBTRate"
                    v-model="FBTRate"
                  />
                  <label class="floatingLabel" for="FBTRate">FBT Rate</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="form-group">
              <select
                v-model="financierId"
                class="form-control sits_select"
                disabled
              >
                <option
                  v-for="item in getFinancierDropdownList"
                  :value="item.id"
                  :key="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <label class="floatingLabel" for="FBTRate">Financier</label>
            </div>

            <div class="form-group">
              <input
                type="number"
                step="any"
                class="form-control"
                id="interest"
                placeholder=" "
                autocomplete="off_interest"
                v-model="financierInterest"
                disabled
              />
              <label class="floatingLabel" for="interest">Financier rate</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <hr />
            <div class="text-right">
              <button
                type="button"
                @click="fnUpdate"
                class="btn btn-primary btn-sm"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../../services/message.service'
import * as lookupValuesService from '../../../services/lookupValues.service'

export default {
  data() {
    return {
      brokerage: '',
      brokerageVSADefault: '',
      GAPInsurance: '',
      GAPInsuranceVSA: '',
      GST: '',
      GSTLimit: '',
      GSTMaxOnAssets: '',
      financierId: '',
      interest: 0,
      leaseAdminFee: '',
      leaseAdminFeeVSA: '',
      mcLeaseFee: '',
      PPSRFee: '',
      medicare: '',
      registration: '',
      tyreReplaceFreq: '',
      tyreWheelInsurance: '',
      FBTRate: ''
    }
  },
  computed: {
    ...mapGetters(['getLookupValuesAll', 'getFinancierDropdownList']),
    financierInterest() {
      const list = this.getFinancierDropdownList
      let financierId = this.financierId

      if (Number(financierId) > 0 && list.length > 0) {
        let obj = list.find(function (item) {
          if (item.id == financierId) return item.rate
        })

        return obj.rate
      }

      return 0
    }
  },
  methods: {
    ...mapActions(['fetchLookupValuesAll', 'fetchFinancierDropdownList']),
    fnUpdate: async function () {
      const obj = {
        brokerage: this.brokerage,
        brokerageVSADefault: this.brokerageVSADefault,
        GAPInsurance: this.GAPInsurance,
        GAPInsuranceVSA: this.GAPInsuranceVSA,
        GST: this.GST,
        GSTLimit: this.GSTLimit,
        GSTMaxOnAssets: this.GSTMaxOnAssets,
        financierId: this.financierId,
        interest: this.financierInterest,
        leaseAdminFee: this.leaseAdminFee,
        leaseAdminFeeVSA: this.leaseAdminFeeVSA,
        mcLeaseFee: this.mcLeaseFee,
        PPSRFee: this.PPSRFee,
        medicare: this.medicare,
        registration: this.registration,
        tyreReplaceFreq: this.tyreReplaceFreq,
        tyreWheelInsurance: this.tyreWheelInsurance,
        FBTRate: this.FBTRate
      }

      try {
        await lookupValuesService.update(1, obj)
        messageService.fnSweetAlertSuccessToast(
          'Lookup values',
          'Updated successfully'
        )
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Lookup values - update',
          error.response.data.message
        )
      }
    }
  },
  created() {
    this.fetchFinancierDropdownList()
    this.fetchLookupValuesAll()
  },
  watch: {
    getLookupValuesAll: function (val) {
      this.brokerage = val.brokerage
      this.brokerageVSADefault = val.brokerageVSADefault
      this.GAPInsurance = val.GAPInsurance
      this.GAPInsuranceVSA = val.GAPInsuranceVSA
      this.GST = val.GST
      this.GSTLimit = val.GSTLimit
      this.GSTMaxOnAssets = val.GSTMaxOnAssets
      this.financierId = val.financierId
      this.interest = val.interest
      this.leaseAdminFee = val.leaseAdminFee
      this.leaseAdminFeeVSA = val.leaseAdminFeeVSA
      this.mcLeaseFee = val.mcLeaseFee
      this.PPSRFee = val.PPSRFee
      this.medicare = val.medicare
      this.registration = val.registration
      this.tyreReplaceFreq = val.tyreReplaceFreq
      this.tyreWheelInsurance = val.tyreWheelInsurance
      this.FBTRate = val.FBTRate
    }
  }
}
</script>
